import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';

import { BaseContext } from 'context/base.context';
import { RoutePath } from 'routes/route-path.constant';

import { useSaveAnswers } from 'hooks/use-save-answers.hook';
import { useLocalStorage } from 'hooks/use-local-storage.hook';

import { LocalStorageKeys } from 'constants/local-storage';
import { TypographyVariants } from 'constants/typography-variants';

import { Typography } from 'components/typography';
import { ChoiceButton, ChoiceType } from 'components/choice-button';

export const BehaviourChangeImportance = () => {
    const { t } = useTranslation();
    const saveAnswers = useSaveAnswers();

    const pageKey = LocalStorageKeys[RoutePath.BehaviourChangeImportance];

    const { pageValue, setPageValue }: any = useLocalStorage({
        key: pageKey,
        defaultValue: '',
    });

    const { pageConfiguration } = useContext(BaseContext);

    const answers: ChoiceType[] = [
        {
            key: 'very-important',
            value: t('behaviour-change-importance-option-very-important'),
        },
        {
            key: 'little-important',
            value: t('behaviour-change-importance-option-little-important'),
        },
        {
            key: 'not-important',
            value: t('behaviour-change-importance-option-not-important'),
        },
    ];

    const handleClick = (answer: ChoiceType) => {
        setPageValue(answer.key);

        saveAnswers({
            key: pageKey,
            itemQuestion: { question: t('behaviour-change-importance-title'), value: t(answer.value) },
        });

        pageConfiguration.handleOnPageComplete(answer.key);
    };

    return (
        <>
            <Typography variant={TypographyVariants.h1} typographyNext>
                {t('behaviour-change-importance-title')}
            </Typography>

            {answers.map((v: ChoiceType) => (
                <ChoiceButton
                    key={v.key}
                    center={true}
                    selected={v.key === pageValue}
                    typographyText={v.value}
                    onClick={() => handleClick(v)}
                />
            ))}
        </>
    );
};
